export {
  NEXT_PUBLIC_APP_ORIGIN,
  NEXT_PUBLIC_MIXPANEL_TOKEN,
  NEXT_PUBLIC_ROOT_DOMAIN,
  NEXT_PUBLIC_ROOT_DOMAIN_LEGACY,
  NEXT_PUBLIC_TINYBIRD_TOKEN,
  NEXT_PUBLIC_TINYBIRD_ENV,
};

import { z } from 'zod';

const EnvsClientSchema = z.object({
  NEXT_PUBLIC_APP_ORIGIN: z.string(),
  NEXT_PUBLIC_MIXPANEL_TOKEN: z.string(),
  NEXT_PUBLIC_ROOT_DOMAIN: z.string(),
  NEXT_PUBLIC_ROOT_DOMAIN_LEGACY: z.string(),
  NEXT_PUBLIC_TINYBIRD_TOKEN: z.string(),
  NEXT_PUBLIC_TINYBIRD_ENV: z.string(),
});

const envs = EnvsClientSchema.parse({
  NEXT_PUBLIC_APP_ORIGIN: process.env.NEXT_PUBLIC_APP_ORIGIN,
  NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
  NEXT_PUBLIC_ROOT_DOMAIN: process.env.NEXT_PUBLIC_ROOT_DOMAIN,
  NEXT_PUBLIC_ROOT_DOMAIN_LEGACY: process.env.NEXT_PUBLIC_ROOT_DOMAIN_LEGACY,
  NEXT_PUBLIC_TINYBIRD_TOKEN: process.env.NEXT_PUBLIC_TINYBIRD_TOKEN,
  NEXT_PUBLIC_TINYBIRD_ENV: process.env.NEXT_PUBLIC_TINYBIRD_ENV,
});

const {
  NEXT_PUBLIC_APP_ORIGIN,
  NEXT_PUBLIC_MIXPANEL_TOKEN,
  NEXT_PUBLIC_ROOT_DOMAIN,
  NEXT_PUBLIC_ROOT_DOMAIN_LEGACY,
  NEXT_PUBLIC_TINYBIRD_TOKEN,
  NEXT_PUBLIC_TINYBIRD_ENV,
} = envs;
